export function executeCommand(cmd, context = {}) {
    const trimmed = cmd.trim();
    if (!trimmed) return [];

    const { canExitDev } = context;

    

    if (trimmed === 'help') {
        const cmds = [
            'help', 'clear', 'man',
            'whoami', 'finger',
            'uname -a', 'uptime',
            'ps', 'ps aux', 'top',
            'ls ./work',
            'capabilities --domain',
            'timeline',
            'logs', 'logs --career',
            'logs --errors', 'logs --milestones',
            'regret --show',
            'metrics',
            'source ./journey.sh',
            'chmod', 'sudo',
            'establish-connection',
            'export resume.pdf',
        ];

        if (canExitDev) cmds.push('hrmode');

        return [
            { type: 'out', text: 'Available commands:' },
            { type: 'help-grid', items: cmds },
            { type: 'out', text: '' },
            { type: 'out', text: 'Use `man <command>` to understand intent.' },
        ];
    }

    if (trimmed.startsWith('man ')) {
        const target = trimmed.slice(4);

        const MAN = {
            help: 'Lists all available commands.',
            clear: 'Clears the terminal screen.',
            man: 'Explains what a command does.',
            whoami: 'Prints system identity.',
            finger: 'Explains thinking style and values.',
            'uname -a': 'Shows technical environment.',
            uptime: 'Shows how long the system has been running.',
            ps: 'Lists background processes.',
            'ps aux': 'Shows resource-heavy processes.',
            top: 'Shows current dominant focus.',
            'ls ./work': 'Lists produced work artifacts.',
            'capabilities --domain': 'Shows skill levels honestly.',
            timeline: 'Shows major transitions.',
            logs: 'Shows recurring behavioral patterns.',
            'logs --career': 'Shows long-term trajectory.',
            'logs --errors': 'Shows failure patterns.',
            'logs --milestones': 'Shows irreversible milestones.',
            'regret --show': 'Shows known regrets.',
            metrics: 'Shows quantified effort.',
            'source ./journey.sh': 'Runs life narrative.',
            chmod: 'Attempts permission change (denied).',
            sudo: 'Attempts privilege escalation (denied).',
            'establish-connection': 'Initiates contact handshake.',
            'export resume.pdf': 'Exports resume.',
            hrmode: 'Exit terminal (desktop only).',
        };

        return MAN[target]
            ? [
                { type: 'out', text: `${target}:` },
                { type: 'out', text: MAN[target] },
            ]
            : [{ type: 'out', text: `man: no entry for ${target}` }];
    }

    

    switch (trimmed) {
        case 'clear':
            return { type: 'CLEAR' };

        case 'hrmode':
            if (!canExitDev) {
                return [{ type: 'out', text: 'hrmode: unavailable on this device' }];
            }
            return { type: 'EXIT_DEV' };

        case 'whoami':
            return [{ type: 'out', text: 'Backend & Systems Engineer' }];

        case 'finger':
            return [
                { type: 'out', text: 'Prefers correctness over speed' },
                { type: 'out', text: 'Optimizes for long-term clarity' },
                { type: 'out', text: 'Avoids unnecessary cleverness' },
                { type: 'out', text: 'Accepts slower paths for depth' },
            ];

        case 'uname -a':
            return [
                { type: 'out', text: 'Kernel: learning-oriented, system-first' },
                { type: 'out', text: 'Architecture: modular, iterative' },
                { type: 'out', text: 'Environment: JS / TS / Linux / Cloud' },
            ];

        case 'uptime':
            return [
                { type: 'out', text: 'System uptime: <CAREER START → NOW>' },
                { type: 'out', text: 'Last restart: <NONE>' },
            ];

        case 'ps':
            return [
                { type: 'out', text: 'curiosity' },
                { type: 'out', text: 'problem-solving' },
                { type: 'out', text: 'pattern-recognition' },
            ];

        case 'ps aux':
            return [
                { type: 'out', text: 'learning systems (high CPU)' },
                { type: 'out', text: 'building artifacts (steady memory)' },
                { type: 'out', text: 'long-term planning (background)' },
            ];

        case 'top':
            return [
                { type: 'out', text: 'PRIMARY: system thinking' },
                { type: 'out', text: 'SECONDARY: skill consolidation' },
                { type: 'out', text: 'IDLE: experimentation' },
            ];

        case 'ls ./work':
            return [
                { type: 'out', text: 'portfolio-os/' },
                { type: 'out', text: 'systems-notes/' },
                { type: 'out', text: 'experiments/' },
                { type: 'out', text: 'learning-logs/' },
            ];

        case 'capabilities --domain':
            return [
                { type: 'out', text: 'Systems: functional → confident' },
                { type: 'out', text: 'Backend: functional' },
                { type: 'out', text: 'Frontend: sufficient for tooling' },
                { type: 'out', text: 'Theory: learning' },
            ];

        case 'timeline':
            return [
                { type: 'out', text: 'curiosity → learning' },
                { type: 'out', text: 'learning → building' },
                { type: 'out', text: 'building → system thinking' },
                { type: 'out', text: 'system thinking → portfolio OS' },
            ];

        case 'logs':
            return [
                { type: 'out', text: '[INFO] learning continuously' },
                { type: 'out', text: '[INFO] building incrementally' },
                { type: 'out', text: '[INFO] refactoring understanding' },
            ];

        case 'logs --career':
            return [
                { type: 'out', text: '[TRACE] exploration phase' },
                { type: 'out', text: '[TRACE] focus narrowing' },
                { type: 'out', text: '[TRACE] depth over breadth' },
            ];

        case 'logs --errors':
            return [
                { type: 'out', text: '[WARN] overengineering early' },
                { type: 'out', text: '[WARN] optimizing before clarity' },
            ];

        case 'logs --milestones':
            return [
                { type: 'out', text: '[OK] first real system shipped' },
                { type: 'out', text: '[OK] standards raised' },
            ];

        case 'regret --show':
            return [
                { type: 'out', text: 'Started systems thinking earlier' },
                { type: 'out', text: 'Shipped sooner, polished later' },
                { type: 'out', text: 'Trusted boring solutions faster' },
            ];

        case 'metrics':
            return [
                { type: 'out', text: 'Years building: <PLACEHOLDER>' },
                { type: 'out', text: 'Hours/week: <PLACEHOLDER>' },
                { type: 'out', text: 'Artifacts shipped: <PLACEHOLDER>' },
            ];

        case 'source ./journey.sh':
            return [
                { type: 'out', text: '[ OK ] sourcing journey.sh' },
                { type: 'out', text: '→ initialized curiosity' },
                { type: 'out', text: '→ learned fundamentals' },
                { type: 'out', text: '→ building portfolio OS' },
                { type: 'out', text: '[ DONE ] journey initialized' },
            ];

        case 'chmod':
            return [{ type: 'out', text: 'permission denied (immutable system)' }];

        case 'sudo':
            return [
                { type: 'out', text: 'authentication failure' },
                { type: 'out', text: 'authority not granted' },
            ];

        case 'establish-connection':
        case 'establish connection':
            return [
                { type: 'out', text: 'handshake initiated' },
                { type: 'out', text: 'endpoints available' },
                { type: 'out', text: 'trust: uninitialized' },
            ];

        case 'export resume.pdf':
            return [
                { type: 'out', text: 'compiling structured profile' },
                { type: 'out', text: 'export complete' },
            ];

        default:
            return [{ type: 'out', text: `command not found: ${trimmed}` }];
    }
}
